export const config = {
  imgUrl: process.env.REACT_APP_IMG_URL,
  locale: 'ru',
} as const
